// extracted by mini-css-extract-plugin
export default {"form":"change-all-modal_form__g4aAa","buttons":"change-all-modal_buttons__Bf4kg","button":"change-all-modal_button__x1IWx"};